import React from 'react';
import PropTypes from 'prop-types';

export default function PaymentsOutlined({ color, ...rest }) {
  return (
    <svg fill={color} viewBox="0 0 27.4 27.4" {...rest}>
      <path d="M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2m-2 0H3V6h14zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3m13 0v11c0 1.1-.9 2-2 2H4v-2h17V7z" />
    </svg>
  );
}

PaymentsOutlined.defaultProps = {
  color: 'currentColor',
  height: 27.4,
  width: 27.4,
};

PaymentsOutlined.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};
